/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MatchTerminationType = {
    properties: {
        code: {
            type: 'string',
            isRequired: true,
        },
        translation: {
            type: 'Translation',
            isRequired: true,
        },
    },
} as const;
